import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 3910AABC-4BEB-4D91-B35D-AAE58A1115C8
 * name picture-in-picture-top-right-outline
 * version: 3.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/picture-in-picture-top-right-outline.svg
 * tags
 */
export const PictureInPictureTopRightOutlineIcon = createSvgIcon(<><path d="M19,7H11V13H19V7M17,11H13V9H17V11M21,3H3A2,2 0 0,0 1,5V19C1,20.11 1.9,21 3,21H21A2,2 0 0,0 23,19V5C23,3.91 22.1,3 21,3M21,19H3V5H21V19Z" /></>, 'PictureInPictureTopRightOutlineIcon');
export default PictureInPictureTopRightOutlineIcon